export const SET_WHATSAPP_RESTAURANT_STATE = "SET_WHATSAPP_RESTAURANT_STATE";
export const SET_WHATSAPP_RESET_IS_LOADING = "SET_WHATSAPP_RESET_IS_LOADING";
export const SET_WHATSAPP_IS_LOADING = "SET_WHATSAPP_IS_LOADING";

export const SET_TG_RESTAURANT_STATE = "SET_TG_RESTAURANT_STATE";
export const SET_TG_RESET_IS_LOADING = "SET_TG_RESET_IS_LOADING";
export const SET_TG_PHONE_IS_LOADING = "SET_TG_PHONE_IS_LOADING";
export const SET_TG_CODE_IS_LOADING = "SET_TG_CODE_IS_LOADING";
export const SET_TG_PASSWORD_IS_LOADING = "SET_TG_PASSWORD_IS_LOADING";
